import { render, staticRenderFns } from "./ControllerEditItem.vue?vue&type=template&id=7b988a20&scoped=true&"
import script from "./ControllerEditItem.vue?vue&type=script&lang=js&"
export * from "./ControllerEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b988a20",
  null
  
)

export default component.exports